'use strict';

function initBelowFoldRegion() {
  var $belowFoldRegion = $('.pd-async-region');

  // Render any components in the Below Fold region via ajax after page load
  $belowFoldRegion.each(function (i, el) {
    var $el = $(el);
    var belowFoldObserver = new IntersectionObserver(function (entries, _observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          belowFoldObserver.unobserve(entry.target);
          var url = $el.data('url');
          var populateRegion = new Promise(function (resolve) {
            var $xhr = $el.data('$xhr');
            $xhr && $xhr.abort && $xhr.abort();

            // Send to Page-Show, return HTML for ajaxRegion template
            $el.data('$xhr', $.ajax({
              url: url,
              method: 'GET',
              beforeSend: function beforeSend() {
                $el.addClass('loading');
                $el.spinner().start();
              },
              success: function success(response) {
                var $html = $(response);
                $el.replaceWith($html);
                resolve($html);
              },
              error: function error(err) {
                console.error('Unable to render Below Fold region ', err);
              },
              complete: function complete() {
                $el.removeClass('loading');
                $el.spinner().stop();
              }
            }));
          });
          populateRegion.then(function ($html) {
            var reinitFiles = require('core/utilities/ajaxHelpers');
            var processInclude = require('base/util');

            // Init pageLoad
            reinitFiles.methods.animateIfVisible($html.find('[data-animation]'), 'initialPageLoad');

            // init global pageDesigner events: animations, buttons, hero
            processInclude(reinitFiles['pageDesigner']);

            // init product tiles
            if ($html.find('.product-tile').length > 0) {
              processInclude(reinitFiles['productTile']);
            }
            // init einstein slider
            $(document).trigger('load.einstein');

            // init sliders
            if ($html.find('.slider-container').length > 0) {
              var $sliders = $html.find('.slider-container');
              $sliders.each(function (_index, slider) {
                var $slider = $(slider);
                if ($slider.closest('.experience-commerce_layouts-sliderEinstein').length > 0) {
                  reinitFiles['einstein'].init($slider.parent());
                } else {
                  reinitFiles['slider'].initializeSliders($slider.parent());
                }
              });
            }

            // init videos
            if ($html.find('.video-container').length > 0) {
              processInclude(reinitFiles['video']);
            }
          });
        }
      });
    }, {});
    belowFoldObserver.observe(el);
  });
}
function initShowMoreContentButton() {
  // Delegating this event to body in case Content Grid component is loaded in Below Fold region
  $('body').on('click', '.show-more-content button', function (e) {
    var _this = this;
    e.stopPropagation();
    var $target = $(event.target);
    var showMoreUrl = $(this).data('url');
    e.preventDefault();
    var $xhr = $target.data('$xhr');
    $xhr && $xhr.abort && $xhr.abort();
    $target.data('$xhr', $.ajax({
      url: showMoreUrl,
      data: {
        selectedUrl: showMoreUrl
      },
      method: 'GET',
      context: $target.closest('.content-grid-footer'),
      beforeSend: function beforeSend() {
        _this.spinner().start();
      },
      success: function success(response) {
        this.replaceWith(response);
      },
      complete: function complete() {
        this.spinner().stop();
      }
    }));
  });
}
module.exports = {
  initBelowFoldRegion: initBelowFoldRegion,
  initShowMoreContentButton: initShowMoreContentButton
};